var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterIcon32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "url(#paint0_linear_402_1714)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8308 12.6907C27.8943 13.1895 26.3465 14.4878 25.481 16.351C24.9895 17.3999 24.9529 17.6199 24.9162 19.6371L24.8795 21.4562H26.0238H27.1681V19.9819C27.1681 18.8816 27.1974 18.3975 27.2855 18.0601C27.5495 17.0478 28.2537 16.0502 29.1339 15.4707C30.1828 14.7739 31.5765 14.5759 32.7795 14.9573C34.1878 15.4047 35.3395 16.6077 35.7209 18.0454C35.7942 18.3461 35.8456 18.9623 35.8749 19.9672L35.9189 21.4562H37.0045H38.0975V19.8132C38.0975 18.3168 38.0828 18.1114 37.9214 17.4732C37.32 15.1113 35.4935 13.2849 33.1316 12.6834C32.1487 12.434 30.8063 12.4413 29.8308 12.6907Z",
    fill: "url(#paint1_linear_402_1714)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4759 23.7962C15.3585 23.8769 15.2045 24.0383 15.1238 24.1557C14.9917 24.3611 14.9917 24.7278 15.0064 35.0704L15.0284 45.7724L15.2265 46.3152C15.5712 47.2468 15.916 47.7749 16.6348 48.4864C17.3977 49.2493 18.1385 49.6674 19.1288 49.9168C19.6936 50.0635 19.9797 50.0635 31.4959 50.0635C43.0121 50.0635 43.2982 50.0635 43.863 49.9168C44.1784 49.8361 44.7212 49.6307 45.0659 49.462C45.5721 49.2126 45.8215 49.0219 46.3863 48.4497C46.9584 47.8849 47.1491 47.6355 47.3985 47.1294C47.5672 46.7847 47.7726 46.2419 47.8533 45.9264C47.9927 45.3616 48 45.0756 48 34.8503C48 24.6911 47.9927 24.3464 47.8606 24.141C47.7873 24.031 47.6259 23.8696 47.5159 23.7962C47.3105 23.6642 46.8557 23.6569 31.4959 23.6569C16.0627 23.6569 15.6813 23.6642 15.4759 23.7962ZM36.4911 29.2243C38.4569 29.437 40.1 30.7793 40.6208 32.6058C40.6795 32.8258 41.0169 34.711 41.369 36.7868C42.1099 41.2539 42.1245 41.5107 41.6844 42.4349C41.0609 43.7406 39.9093 44.4961 38.5376 44.4961C37.5474 44.4961 36.7332 44.166 36.0437 43.4692C35.6916 43.1244 35.5155 42.831 34.8994 41.6134L34.1732 40.161H31.4959H28.8185L28.1144 41.5694C27.3662 43.0657 27.0214 43.5498 26.3906 43.968C25.8551 44.32 25.2096 44.5034 24.4981 44.5034C23.0898 44.4961 21.9382 43.7552 21.3073 42.4349C20.8672 41.5107 20.8819 41.2539 21.6227 36.7868C21.9748 34.711 22.3122 32.8258 22.3709 32.6058C22.8771 30.838 24.5568 29.4297 26.3979 29.2316C27.1461 29.1509 35.7503 29.1509 36.4911 29.2243Z",
    fill: "url(#paint2_linear_402_1714)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1412 31.4248C25.7671 31.5421 25.3563 31.7989 25.0556 32.0923C24.4761 32.6718 24.4468 32.8038 23.7573 36.9115C23.4125 38.98 23.1338 40.8431 23.1338 41.0485C23.1338 41.5473 23.3758 41.9727 23.794 42.2075C24.0507 42.3468 24.1754 42.3762 24.5935 42.3468C25.3784 42.3028 25.4077 42.2662 26.4713 40.161C27.2782 38.5619 27.4249 38.3125 27.6669 38.1658L27.9383 37.9971H31.4959C34.9214 37.9971 35.0608 38.0044 35.3102 38.1438C35.5302 38.2685 35.6843 38.5252 36.4471 40.0289C36.9312 40.9825 37.408 41.8554 37.5107 41.9581C37.7895 42.2588 38.0462 42.3615 38.5083 42.3615C39.3078 42.3615 39.858 41.826 39.858 41.0485C39.858 40.8358 39.5792 38.98 39.2345 36.9115C38.765 34.1388 38.5596 33.0605 38.4349 32.7891C38.2222 32.3197 37.7674 31.8576 37.276 31.6008L36.8872 31.3954L31.6059 31.3808C28.7012 31.3734 26.2439 31.3954 26.1412 31.4248ZM28.7379 33.772C29.3907 34.2048 29.3907 35.1144 28.7379 35.5471C28.2757 35.8479 27.5276 35.6498 27.2708 35.1584C27.0214 34.6743 27.1828 34.0508 27.6302 33.7794C27.9383 33.5887 28.4591 33.5887 28.7379 33.772ZM35.3395 33.772C35.6549 33.9847 35.8236 34.2855 35.8236 34.6596C35.8236 35.4665 34.9287 35.9652 34.2319 35.5398C33.3443 35.0043 33.7551 33.6327 34.7967 33.6327C34.9948 33.6327 35.2075 33.6913 35.3395 33.772Z",
    fill: "url(#paint3_linear_402_1714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_1714",
    x1: 31.5,
    y1: 0,
    x2: 31.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4190F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_1714",
    x1: 31.4885,
    y1: 21.4562,
    x2: 31.4885,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_1714",
    x1: 31.5,
    y1: 50.0635,
    x2: 31.5,
    y2: 23.6569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_1714",
    x1: 31.4959,
    y1: 42.3615,
    x2: 31.4959,
    y2: 31.3793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon32);
export default __webpack_public_path__ + "static/media/footer_icon_3_2.85e1cc4b8ec6ad47bf507f7a4f4f11f8.svg";
export { ForwardRef as ReactComponent };